import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { User } from './entity-usuarios.model';

export const entityUserAdapter: EntityAdapter<User> =
  createEntityAdapter<User>({
    selectId: (model) => model.id,
    sortComparer: (a: User, b: User): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityUserState extends EntityState<User> {
  isLoading?: boolean;
  hasAddedSuccess?: boolean;
  error?: Error | null | any;
}

export const initialState: EntityUserState =
  entityUserAdapter.getInitialState({
    hasAddedSuccess: false,
    isLoading: false,
    error: null
  });
